(ns ui.components.input.checkbox-group
  (:require
   [ui.components.input.checkbox :as checkbox]
   [ui.util :as uu]))

(defn view
  [{:keys [value options on-change horizontal? on-blur on-focus]}]
  (into [:div
         {:class (if horizontal?
                   "flex flex-wrap gap-5"
                   "flex flex-col gap-3")}]
        (for [opt options]
          (let [checked? (contains? (set value) (:value opt))
                disabled? (boolean (:disabled? opt))]
            [:label
             {:class (uu/cm "flex gap-2 font-semibold cursor-pointer group text-base-light-text-paler"
                            (if disabled?
                              "cursor-not-allowed"
                              "cursor-pointer"))}
             [checkbox/view
              {:value     checked?
               :disabled? disabled?
               :on-change (fn [v]
                            (on-change (if v
                                         (concat value [(:value opt)])
                                         (->> value
                                              (remove (fn [va]
                                                        (= va (:value opt))))))))
               :on-focus  (fn [e]
                            (when (fn? on-focus)
                              (on-focus e)))
               :class     nil
               :on-blur   (fn [e]
                            (when (fn? on-blur)
                              (on-blur e)))}]
             (:label opt)]))))
